import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

const BASE_IMG_PATH = '/manimg/common/img/';

/**
 * Component provide show custom icon from sprite or img from assets
 */
@Component({
  selector: 'isp-icon-provider',
  templateUrl: './icon-provider.component.html',
  styleUrls: ['./scss/icon-provider.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconProviderComponent implements OnChanges {
  /** Icon name or url to image */
  @Input() nameOrUrl: string;

  /** Icon/img size */
  @Input() size: string;

  /** Icon/img width */
  @Input() width: string;

  /** Icon/img height */
  @Input() height: string;

  /** Show icon from sprite */
  @Input() inSprite: boolean;

  iconsStyle?: Partial<CSSStyleDeclaration>;

  imgBackground?: string;

  constructor(private readonly cdr: ChangeDetectorRef) {}

  private updateIconsStyle(): void {
    const width = this.width || this.size;
    const height = this.height || this.size;
    if (width || height) {
      this.iconsStyle = {
        width,
        height,
      };
    } else {
      delete this.iconsStyle;
    }
    this.cdr.markForCheck();
  }

  private updateImgPath(): void {
    if (!this.inSprite) {
      const isUrl = this.nameOrUrl.startsWith('/manimg/');
      const url = isUrl
        ? this.nameOrUrl
        : `${BASE_IMG_PATH}${this.nameOrUrl}.png`;
      this.imgBackground = `url(${url}) top left / cover no-repeat `;
    } else {
      delete this.imgBackground;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.size || changes.height || changes.width) {
      this.updateIconsStyle();
    }

    if (changes.nameOrUrl) {
      this.updateImgPath();
    }
  }
}
